import {ItemGroup} from "./itemGroup";

export class GroupRepository {
	private static groups: {[name: string]: typeof ItemGroup} = {};

	static register(name: string, group: typeof ItemGroup){
		GroupRepository.groups[name] = group;
		return group;
	}

	static byName(name: string): typeof ItemGroup {
		return GroupRepository.groups[name] || ItemGroup;
	}
}
